import * as React from "react";
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Route, Link, Switch } from "react-router-dom";
import { Grid } from "@components/Grid/Grid"

@inject("store")
export default class SizeChart extends React.Component {

    constructor(props) {
        super(props);
        //this.handleFilterClick = this.handleFilterClick.bind(this);
        this.state = { content: null };
    }

    UNSAFE_componentWillMount() {
        const navigation = this.props.store.navigation;

        navigation.GetGrid("/" + navigation.LanguageCode + "-" + navigation.MarketCode + "/settings/sizechart").then(
            result => {
                this.setState({ content: result });
                //console.log(result);
            }
        );
    }

    //handleFilterClick() {
    //    const navigation = this.props.store.navigation;
    //    navigation.toolbarRouter.push("/sort");
    //}

    render() {
        if (!this.state.content) return null;

        return (
            <div className="size-chart-container">
                <Grid {...this.props} model={this.state.content.Properties.grid} /*repeater={repeater}*/ />
            </div>
        );
    }
}


